import styled from "styled-components";
import CustomIcon from "../Global/Icons/CustomIcon";

//If position fixed add width 100%
const BottomBorder = styled.div`
    position: relative;
    bottom: 0;
    background-color: white;
    border-bottom: 5px solid #86BC25;
    margin-top: auto;
    padding: 34px 0px 24px 64px;
`;

export const Footer = () => {
    return(
        <BottomBorder as="footer" id="main-footer">
            <CustomIcon icon={"BrandLogo"} width={100} height={35} />
        </BottomBorder>
    )
};